import React, { useState, useEffect } from "react";
import AIRalert from "components/General/alert/alert";
import "./auth.css";
import useUser from "hooks/useUser";
import loadingGif from "assets/gifs/loading.gif";

//Firebase
import "firebase/auth";
import { useFirebaseApp, useUser as useUserFirebase } from "reactfire";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

export default function SignUp() {
  const {
    register,
    error,
    success,
    profile,
    loadingUser,
    login_google,
    logout,
  } = useUser();
  const history = useHistory();

  const firebase = useFirebaseApp();
  const user = useUserFirebase();

  return (
    <>
      {loadingUser ? (
        <img className="loadingGif" src={loadingGif} alt="" />
      ) : user.data ? (
        <button
          type="button"
          className="login-with-google-btn"
          onClick={logout}
        >
          <i className="fab fa-google"></i>{" "}
          <span>Hi {user.data.displayName.split(" ")[0]} | Logout</span>
        </button>
      ) : (
        <button
          type="button"
          className="login-with-google-btn"
          onClick={login_google}
        >
          <i className="fab fa-google"></i> <span>Sign in with Google</span>
        </button>
      )}
      <AIRalert visible={error.status} text={error.msg} type="error"></AIRalert>
      <AIRalert
        visible={success.status}
        text={success.msg}
        type="success"
      ></AIRalert>
    </>
  );
}
